<template>
  <div class="d-flex align-items-center">
    <div
      class="avatar mr-3 rounded-circle shine"
      :style="{ height: `${avatarSize}px`, width: `${avatarSize}px` }"
    ></div>
    <div class="title shine col-8" :style="{ height: `${lineHeight}px` }"></div>
  </div>
</template>

<script>
export default {
  name: 'AvatarTitle',
  props: {
    avatarSize: {
      default: 30
    },
    lineHeight: {
      default: 30
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  border-radius: 10px;
}
</style>
